import { useState } from 'react';
import { enqueueSnackbar } from 'notistack';
import { handleDownloadFile } from '../../../utils/utils';
import { getLmsOnHandReport } from '../api';

const initialState = {
  locationCode: null,
  destinationCode: null,
  fileType: 2,
};

export default function useLmsOnHandReport(isAdmin: boolean) {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [locationCode, setLocationCode] = useState<string | null>(
    initialState.locationCode,
  );
  const [destinationCode, setDestinationCode] = useState<string | null>(
    initialState.destinationCode,
  );
  const [fileType, setFileType] = useState<string | number>(
    initialState.fileType,
  );

  const curPayload = {
    locationCode,
    destinationCode,
    fileType,
  };

  const onChangeLocationCode = (location: string) => {
    setLocationCode(location);
  };

  const onChangeDestinationCode = (destination: string) => {
    setDestinationCode(destination);
  };

  const onChangeFileType = (type: string) => {
    setFileType(type);
  };

  const clearFilters = () => {
    setLocationCode(initialState.locationCode);
    setDestinationCode(initialState.destinationCode);
    setFileType(initialState.fileType);
  };

  const fetchLmsOnHandReport = async (payload: any) => {
    const { report } = await getLmsOnHandReport(payload, isAdmin, setIsLoading);

    if (report !== null && report.hasOwnProperty('report')) {
      handleDownloadFile(
        report.report,
        `on_hand_report.${fileType === 1 ? 'pdf' : 'xlsx'}`,
        true,
      );
    } else {
      enqueueSnackbar('An error occured while downloading the report.', {
        variant: 'error',
      });
    }
  };

  const onClickDownload = () => {
    setIsLoading(true);
    fetchLmsOnHandReport(curPayload);
  };

  return {
    isLoading,
    locationCode,
    onChangeLocationCode,
    destinationCode,
    onChangeDestinationCode,
    fileType,
    onChangeFileType,
    clearFilters,
    onClickDownload,
  };
}
